// extracted by mini-css-extract-plugin
export var dataCell = "_kj-2";
export var dataRow = "_kj-0";
export var headerRow = "_kj-1";